import { sanitizeCsvRow } from './csv-sanitize';
import { convertFileFromUtf8WithBomToUtf8 } from './csv-ut8';

const allowedSeparator = [',', ';', ':'] as const;

export const csvReader = async <T extends { [key: string]: string }>({
  file,
  callback,
}: {
  file: File;
  callback: ({
    row,
    index,
  }: {
    headers: string[];
    separator: string;
    row: T;
    index: number;
  }) => void;
}) => {
  const _fileText = await file.text();
  const ut8Text = convertFileFromUtf8WithBomToUtf8(_fileText);

  const rows = ut8Text.split(/\r\n|\n/).filter((row) => row.length > 2);

  const [headersStr, ...dataRows] = rows;
  if (!headersStr) {
    throw new Error('Invalid csv headers');
  }

  const separator = allowedSeparator.find(
    (s) => headersStr.split(s).length > 1,
  );

  if (!separator) {
    throw new Error('Invalid csv separator');
  }
  const headers = headersStr.split(separator);

  let index: number = 0;
  for (const row of dataRows) {
    const data = row.split(separator);

    const _dataObj = headers.reduce((acc, header, index) => {
      acc[header] = data[index] as any;
      return acc;
    }, {} as any) as T;

    const dataObj = sanitizeCsvRow<T>(_dataObj);

    callback({
      headers,
      separator,
      row: dataObj,
      index,
    });
    index++;
  }
};
